<app-layout>
  <div class="row">
    <div class="col-12" *ngIf="sube">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">{{id === '0' ? 'Yeni Şube' : 'Şube Düzenle'}}</h4>
          <div class="card-options">
            <div class="btn btn-sm btn-pill btn-success" (click)="save()" [ngClass]="{'disabled':sube.isim.length===0 || sube.talepSeri === undefined}">
              Kaydet
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 col-lg-6">
              <div class="mb-3">
                <div class="form-label">Şube Adı</div>
                <input type="text" class="form-control" placeholder="Şube adı" [(ngModel)]="sube.isim">
              </div>
            </div>
            <div class="col-md-12 col-lg-6">
              <div class="mb-3">
                <div class="form-label">Talep Serisi</div>
                <input type="text" class="form-control" placeholder="Talep Serisi" [(ngModel)]="sube.talepSeri">
              </div>
            </div>
            <div class="col-md-12 col-lg-6">
              <div class="mb-3">
                <div class="form-label">Teslimat Adresi</div>
                <input type="text" class="form-control" placeholder="Teslimat Adresi" [(ngModel)]="sube.teslimatAdresi">
              </div>
            </div>
            <div class="col-md-12 col-lg-6">
              <div class="mb-3">
                <div class="form-label">Malzeme Teslim Alındı Mail</div>
                <input type="text" class="form-control" placeholder="Satın Alma Mail" [(ngModel)]="sube.satinAlmaMailAdresi">
              </div>
            </div>
            <div class="col-md-12 col-lg-6">
              <div class="mb-3">
                <div class="form-label">Sipariş Oluşturuldu Mail / Yeni Talep Oluşturuldu</div>
                <input type="text" class="form-control" placeholder="Sipariş Oluşturuldu Mail" [(ngModel)]="sube.siparisOlusturulduMailAdresi">
              </div>
            </div>
            <div class="col-md-12 col-lg-6">
              <div class="mb-3">
                <div class="form-label">Telefon</div>
                <input type="text" class="form-control" placeholder="Telefon" [(ngModel)]="sube.telefon">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-layout>
